import { AM, NA, PM } from "../Constant";

export const convertTo24HourFormat = (time12h: string): string => {
  const [time, modifier] = time12h.split(" ");
  let [hours, minutes] = time.split(":");

  let hourNumber: number = parseInt(hours, 10);

  if (modifier === "PM" && hourNumber !== 12) {
    hourNumber += 12;
  }

  if (modifier === "AM" && hourNumber === 12) {
    hourNumber = 0;
  }

  const paddedHours = hourNumber.toString().padStart(2, "0");
  return `${paddedHours}:${minutes}`;
};

export const convertTo12HourFormat = (time24: string | undefined) => {
  if (!time24) {
    return NA;
  } else {
    const [hours, minutes] = time24?.split(":")?.map(Number);
    const ampm = hours >= 12 ? PM : AM;
    const hours12 = hours % 12 || 12; // Convert 0 to 12 for midnight
    return `${hours12}:${minutes?.toString()?.padStart(2, "0")} ${ampm}`;
  }
};

export const formatMinutesToTime = (totalMinutes: number): string => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (totalMinutes >= 60) {
    const paddedHours = hours.toString().padStart(2, "0");
    const paddedMinutes = minutes.toString().padStart(2, "0");
    return `${paddedHours}:${paddedMinutes}`;
  }

  return `${minutes} min${minutes !== 1 ? "s" : ""}`;
};

export const getTimeDifference = (
  startTime: string,
  endTime: string
): string => {
  if (!startTime || !endTime) {
    return "";
  }

  const [startHours, startMinutes] = startTime.split(":").map(Number);
  const [endHours, endMinutes] = endTime.split(":").map(Number);

  // Convert to total minutes
  const startTotalMinutes: number = startHours * 60 + startMinutes;
  const endTotalMinutes: number = endHours * 60 + endMinutes;

  // Calculate difference
  let diffMinutes: number = endTotalMinutes - startTotalMinutes;

  if (diffMinutes < 0) {
    diffMinutes += 24 * 60; // Handle cases crossing midnight
  }

  // Convert minutes to hours and remaining minutes
  const hours: number = Math.floor(diffMinutes / 60);
  const minutes: number = diffMinutes % 60;

  // Format output
  return hours > 0
    ? `${hours}h ${minutes > 0 ? `${minutes}m` : ""}`.trim()
    : `${minutes}m`;
};

export const parseTimeToMinutes = (timeStr: string) => {
  const [hour, minutes] = timeStr.split(":").map(Number);
  return hour * 60 + minutes;
};

export const calculateDuration = (
  startTime: string,
  endTime: string
): string => {
  let parsedStartTime;
  let parsedEndTime;
  if (
    startTime.includes("AM") ||
    startTime.includes("PM") ||
    startTime.split(":")[0] >= "12"
  ) {
    parsedStartTime = convertTo24HourFormat(startTime);
  } else {
    parsedStartTime = startTime;
  }
  if (
    endTime.includes("AM") ||
    endTime.includes("PM") ||
    endTime.split(":")[0] >= "12"
  ) {
    parsedEndTime = convertTo24HourFormat(endTime);
  } else {
    parsedEndTime = endTime;
  }

  const parsedStart = parseTimeToMinutes(parsedStartTime);
  const parsedEnd = parseTimeToMinutes(parsedEndTime);

  const diff = parsedEnd - parsedStart;
  return diff.toString();
};
